import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor34Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "7458ab4b-ec42-4636-90ea-8a958f7b3800", "general": {
    "name": "Floor 33,34"
}, "artboards": [{
"background_type": "image",
"image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8%20KP%2010-%2034th%2C%2038th%20FLOOR%20copy.png",
"width": 3846,
"height": 2561,
"use_image_size": true,
"children": [{
    "id": "2b5a4901-34f3-46c1-bfa7-ba5577e23f8d",
    "title": "Poly",
    "type": "poly",
    "x": 48.53232404310926,
    "y": 1.0551765806429803,
    "width": 49.46043165467625,
    "height": 45.80899395140698,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[6].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[6].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[6].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[6] && unitStatus[6].status
            ? `<a href="${unitStatus[6].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/7' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[6].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/7';"
    // },
    "x_image_background": 48.53232404310926,
    "y_image_background": 0.7850759787195685,
    "points": [{
        "x": 100,
        "y": 0.11792365748511278
    }, {
        "x": 100,
        "y": 36.91037680844693
    }, {
        "x": 56.072727272727285,
        "y": 36.91037680844693
    }, {
        "x": 56.29090909090909,
        "y": 94.57547165081972
    }, {
        "x": 45.67272727272728,
        "y": 94.69339618014975
    }, {
        "x": 45.89090909090909,
        "y": 99.88207547066999
    }, {
        "x": 39.127272727272725,
        "y": 100
    }, {
        "x": 39.19999999999998,
        "y": 94.81132070947976
    }, {
        "x": 15.563636363636366,
        "y": 94.69339618014975
    }, {
        "x": 15.41818181818182,
        "y": 21.816037054206173
    }, {
        "x": 0.14545454545454817,
        "y": 21.816037054206173
    }, {
        "x": 0,
        "y": 0.2358481868151187
    }, {
        "x": 97.67272727272726,
        "y": 0
    }]
}, {
    "id": "648e47b7-507a-41be-a333-e7c2ea27843d",
    "title": "Poly",
    "type": "poly",
    "x": 65.36685202619155,
    "y": 54.2649177302078,
    "width": 32.58992805755395,
    "height": 43.54015264945403,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[5].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[5].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[5].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[5] && unitStatus[5].status
            ? `<a href="${unitStatus[5].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/6' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[5].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/6';"
    // },
    "x_image_background": 65.36685202619155,
    "y_image_background": 54.2649177302078,
    "points": [{
        "x": 0.22075055187637968,
        "y": 6.079404466501241
    }, {
        "x": 0,
        "y": 83.62282878411911
    }, {
        "x": 4.083885209713024,
        "y": 83.49875930521092
    }, {
        "x": 4.083885209713024,
        "y": 100
    }, {
        "x": 82.78145695364239,
        "y": 100
    }, {
        "x": 82.89183222958057,
        "y": 83.37468982630273
    }, {
        "x": 94.92273730684326,
        "y": 83.49875930521092
    }, {
        "x": 94.70198675496688,
        "y": 25.682382133995034
    }, {
        "x": 100,
        "y": 25.55831265508685
    }, {
        "x": 99.33774834437085,
        "y": 0
    }, {
        "x": 63.576158940397356,
        "y": 0
    }, {
        "x": 63.796909492273734,
        "y": 6.20347394540943
    }, {
        "x": 49.00662251655629,
        "y": 5.583126550868486
    }, {
        "x": 49.00662251655629,
        "y": 0.24813895781637718
    }, {
        "x": 38.079470198675494,
        "y": 0.12406947890818859
    }, {
        "x": 38.18984547461369,
        "y": 5.955334987593052
    }]
}, {
    "id": "40257499-e80b-41bf-b0ba-39af1613ea32",
    "title": "Poly",
    "type": "poly",
    "x": 55.11505346504046,
    "y": 54.42697785173182,
    "width": 10.143884892086334,
    "height": 43.37809252793001,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[4].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[4].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[4].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[4] && unitStatus[4].status
            ? `<a href="${unitStatus[4].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/5' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[4].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/5';"
    // },
    "x_image_background": 55.11505346504046,
    "y_image_background": 54.42697785173182,
    "points": [{
        "x": 16.666666666666664,
        "y": 0
    }, {
        "x": 16.666666666666664,
        "y": 5.603985056039851
    }, {
        "x": 0,
        "y": 5.47945205479452
    }, {
        "x": 0.7092198581560284,
        "y": 100
    }, {
        "x": 100,
        "y": 99.87546699875467
    }, {
        "x": 100,
        "y": 5.603985056039851
    }, {
        "x": 53.191489361702125,
        "y": 5.72851805728518
    }, {
        "x": 52.4822695035461,
        "y": 0
    }]
}, {
    "id": "0f5d0cc0-4628-43ed-b1b5-74f57b8603c3",
    "title": "Poly",
    "type": "poly",
    "x": 44.935199545441776,
    "y": 54.318937770715806,
    "width": 10.215827338129486,
    "height": 43.432112568438015,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[3].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[3].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[3].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[3] && unitStatus[3].status
            ? `<a href="${unitStatus[3].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/4' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[3].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/4';"
    // },
    "x_image_background": 44.935199545441776,
    "y_image_background": 54.318937770715806,
    "points": [{
        "x": 0.35211267605633806,
        "y": 5.845771144278607
    }, {
        "x": 0,
        "y": 100
    }, {
        "x": 100,
        "y": 99.75124378109453
    }, {
        "x": 99.29577464788733,
        "y": 5.721393034825871
    }, {
        "x": 83.80281690140845,
        "y": 5.721393034825871
    }, {
        "x": 83.45070422535211,
        "y": 0.12437810945273632
    }, {
        "x": 51.76056338028169,
        "y": 0
    }, {
        "x": 51.056338028169016,
        "y": 5.597014925373134
    }]
}, {
    "id": "80b86b86-8338-4c8d-bb9f-fd79861a990d",
    "title": "Poly",
    "type": "poly",
    "x": 34.61145963600213,
    "y": 54.21089768969979,
    "width": 10.251798561151084,
    "height": 43.64819273047004,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[2].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[2].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[2].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[2] && unitStatus[2].status
            ? `<a href="${unitStatus[2].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/3' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[2].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/3';"
    // },
    "x_image_background": 34.61145963600213,
    "y_image_background": 54.21089768969979,
    "points": [{
        "x": 16.49122807017544,
        "y": 0.3712871287128713
    }, {
        "x": 16.842105263157894,
        "y": 6.188118811881188
    }, {
        "x": 0,
        "y": 6.188118811881188
    }, {
        "x": 1.0526315789473684,
        "y": 100
    }, {
        "x": 100,
        "y": 99.62871287128714
    }, {
        "x": 100,
        "y": 5.9405940594059405
    }, {
        "x": 48.771929824561404,
        "y": 5.9405940594059405
    }, {
        "x": 49.122807017543856,
        "y": 0
    }]
}, {
    "id": "08707a79-74f9-4fd3-a76a-647304aa4a4b",
    "title": "Poly",
    "type": "poly",
    "x": 3.8200916317727067,
    "y": 54.2649177302078,
    "width": 30.935251798561154,
    "height": 43.702212770978065,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[1].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[1].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[1].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[1] && unitStatus[1].status
            ? `<a href="${unitStatus[1].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/2' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[1].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/2';"
    // },
    "x_image_background": 3.8200916317727067,
    "y_image_background": 54.2649177302078,
    "points": [{
        "x": 34.18604651162791,
        "y": 0.12360939431396785
    }, {
        "x": 0.3488372093023256,
        "y": 0.12360939431396785
    }, {
        "x": 0,
        "y": 83.0655129789864
    }, {
        "x": 12.44186046511628,
        "y": 83.18912237330038
    }, {
        "x": 12.674418604651164,
        "y": 99.87639060568603
    }, {
        "x": 95.46511627906978,
        "y": 100
    }, {
        "x": 95.34883720930233,
        "y": 83.18912237330038
    }, {
        "x": 100,
        "y": 83.18912237330038
    }, {
        "x": 99.53488372093024,
        "y": 5.80964153275649
    }, {
        "x": 59.53488372093023,
        "y": 5.686032138442522
    }, {
        "x": 59.53488372093023,
        "y": 0
    }, {
        "x": 48.02325581395348,
        "y": 0.4944375772558714
    }, {
        "x": 47.906976744186046,
        "y": 5.933250927070458
    }, {
        "x": 34.06976744186046,
        "y": 5.80964153275649
    }]
}, {
    "id": "a3280e5c-3467-4102-a056-3afc22624d73",
    "title": "Poly",
    "type": "poly",
    "x": 4.118507681053401,
    "y": 1.2173097406896727,
    "width": 37.16616960216083,
    "height": 45.646791359315074,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[0].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[0].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[0].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[0] && unitStatus[0].status
            ? `<a href="${unitStatus[0].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/34/1' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[0].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/34/1';"
    // },
    "x_image_background": 4.118507681053401,
    "y_image_background": 1.2173097406896727,
    "points": [{
        "x": 99.4186046511628,
        "y": 21.563981042654028
    }, {
        "x": 100,
        "y": 0
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0.3875968992248062,
        "y": 27.488151658767773
    }, {
        "x": 25,
        "y": 27.72511848341232
    }, {
        "x": 25.1937984496124,
        "y": 94.54976303317537
    }, {
        "x": 38.759689922480625,
        "y": 95.02369668246445
    }, {
        "x": 38.95348837209303,
        "y": 100
    }, {
        "x": 47.674418604651166,
        "y": 100
    }, {
        "x": 47.674418604651166,
        "y": 94.54976303317537
    }, {
        "x": 79.45736434108527,
        "y": 94.7867298578199
    }, {
        "x": 79.26356589147287,
        "y": 21.32701421800948
    }]
}]
}], "version": "6.0.20"
});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor34Component;
